import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import textTypes from '../textLabel/textTypes';
import TextLabel from '../textLabel/textLabel';

var Thumbnail = /*#__PURE__*/function (_React$Component) {
  _inherits(Thumbnail, _React$Component);

  var _super = _createSuper(Thumbnail);

  function Thumbnail(props) {
    var _this;

    _classCallCheck(this, Thumbnail);

    _this = _super.call(this, props);

    _this.getEllipsisProps = function () {
      return {
        customTrigger: _assertThisInitialized(_this),
        displayCustomTrigger: true
      };
    };

    return _this;
  }

  _createClass(Thumbnail, [{
    key: "getIllustrationContainerClasses",
    value: function getIllustrationContainerClasses() {
      return {
        'illustration-container': true,
        'illustration-background': this.props.hasBackground,
        disabled: this.props.disabled,
        'illustration-image': this.props.illustration && this.props.illustration.type === 'img'
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName('control-thumbnail' + (this.props.fixedRatio ? ' fixed-ratio' : '') + (this.props.disabled ? ' disabled' : '')),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, this.props.illustration ? /*#__PURE__*/React.createElement("div", {
        key: "illustration-container",
        className: _(this.getIllustrationContainerClasses()).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' ')
      }, /*#__PURE__*/React.createElement("div", {
        className: "illustration-inner-container"
      }, this.props.illustration)) : null, this.props.label && this.props.shouldAddTooltipOnEllipsis ? /*#__PURE__*/React.createElement(TextLabel, {
        className: "label",
        value: this.props.label,
        type: this.props.labelType,
        shouldTranslate: this.props.shouldTranslate,
        disabled: this.props.disabled,
        ellipsisProps: this.getEllipsisProps(),
        key: "label"
      }) : null, this.props.label && !this.props.shouldAddTooltipOnEllipsis ? /*#__PURE__*/React.createElement(TextLabel, {
        className: "label",
        key: "noEllipsisLabel",
        value: this.props.label,
        type: this.props.labelType,
        shouldTranslate: this.props.shouldTranslate,
        disabled: this.props.disabled,
        enableEllipsis: false
      }) : null, this.props.children);
    }
  }]);

  return Thumbnail;
}(React.Component);

Thumbnail.displayName = displayNames.THUMBNAIL;
Thumbnail.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelType: PropTypes.string,
  hasBackground: PropTypes.bool,
  illustration: PropTypes.element,
  fixedRatio: PropTypes.bool,
  shouldAddTooltipOnEllipsis: PropTypes.bool,
  disabled: PropTypes.bool
};
Thumbnail.defaultProps = {
  labelType: textTypes.THUMBNAIL_LABEL_DEFAULT_TYPE,
  hasBackground: true,
  shouldAddTooltipOnEllipsis: true
};
export default compose(Thumbnail);